export enum IdentityTypeEnum {
    AADHARA = 'AADHAR',
    PANCARD = 'PANCARD',
    PASSPPORT = 'PASSPORT'
}